export default __webpack_public_path__ + "static/media/review3.e4d0d301.webp";